import React, { useState } from 'react'
import documentServices from '../documentServices';
import { useAlert } from '../../../../context/AlertContext';

function DocumentBarcodeComponent({documentDetails,onSuccess}) {
    const [barcode,setBarcode] = useState("");
    const {AppAlert} = useAlert();
    
    const assigneBarcode = () =>{
        let payload = {
            documentId:documentDetails.id,
            barcode:barcode
        }
        documentServices.barcodeAssign(payload).then(res=>{
            onSuccess();
            AppAlert(res.msg);
        }).catch(error=>{
            AppAlert(error.msg,"error")
        })
        
    }

    return (
        documentDetails.barcode === null ? 
            <div className="input-group mb-3">
                <input type="text" className="form-control" placeholder="Scan barcode here" 
                value={barcode} 
                onChange={(e)=>setBarcode(e.target.value)}
            />
                <button className="btn btn-outline-secondary" type="button" onClick={assigneBarcode}>Assign</button>
            </div>
         : 
            <span className='barcode'>*{documentDetails.barcode}*</span> 
    )
}

export default DocumentBarcodeComponent